<template>
  <div class="modal-content fm-modal-upload">
    <div class="modal-header">
      <h5 class="modal-title">{{ $t('filemanager.modal.modify.title') }}</h5>
      <button type="button" class="close" aria-label="Close" v-on:click="hideModal">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="fm-btn-wrapper">
        <button type="button" class="dropzone col-12" style="cursor:pointer">
          <img style="opacity: 0.5" src="../../../assets/upload.png" alt=""><br>
          <p v-if="newFiles.length > 0">
            <span style="font-weight:500">
              {{ $t('filemanager.info.files') }}
            </span>
            {{ newFiles.length }}
            <span style="font-weight:500">
              {{ $t('filemanager.modal.upload.size') }}
            </span>
            {{ allFilesSize }}
          </p>
          <p>
            {{ $t('filemanager.btn.uploadSelect') }}
          </p>
        </button>
        <input type="file" ref="fileInput" name="myfile"
          v-if="document.extension === 'docx' || document.extension === 'doc'" accept=".docx, .doc"
          v-on:change="selectFiles($event)" />
        <input type="file" ref="fileInput" name="myfile"
          v-if="document.extension === 'xlsx' || document.extension === 'xls'" accept=".xlsx, .xls"
          v-on:change="selectFiles($event)" />
        <input type="file" ref="fileInput" name="myfile"
          v-if="document.extension === 'pptx' || document.extension === 'ppt'" accept=".pptx, .ppt"
          v-on:change="selectFiles($event)" />
        <input type="file" ref="fileInput" name="myfile" v-else :accept="'.' + document.extension"
          v-on:change="selectFiles($event)" />
      </div>
      <div class="fm-upload-list" v-if="countFiles">
        <hr>
        <div class="row">
          <div class="col-md-12" v-for="(item, index) in newFiles" :key="index">
            <div class="row mb-2">
              <div class="col">
                <div class="form-group">
                  <label for="comment">{{ $t('filemanager.modal.modify.comment') }} : </label>
                  <textarea v-model="form.comment" id="comment" rows="2" class="form-control"></textarea>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="w-75 text-truncate mb-2 col-8">
                <img class="mr-3" v-if="item.file.type.indexOf('pdf') !== -1" width="30"
                  src="../../../assets/icons/pdf.png" alt="">
                <img class="mr-3"
                  v-else-if="item.file.name.indexOf('.doc') !== -1 || item.file.name.indexOf('.docx') !== -1" width="30"
                  src="../../../assets/icons/word.svg" alt="">
                <img class="mr-3"
                  v-else-if="item.file.name.indexOf('.xls') !== -1 || item.file.name.indexOf('.xlsx') !== -1" width="30"
                  src="../../../assets/icons/excel.svg" alt="">
                <img class="mr-3"
                  v-else-if="item.file.name.indexOf('.ppt') !== -1 || item.file.name.indexOf('.pptx') !== -1" width="30"
                  src="../../../assets/icons/powerpoint.svg" alt="">
                <i class="far" v-else style="font-size: 30px;margin-right:15px"
                  v-bind:class="mimeToIcon(item.file.type)" />
                <span style="font-weight:500">{{ item.file.name }}</span>
              </div>
              <div class="text-right col-2">
                {{ bytesToHuman(item.file.size) }}
              </div>
              <div class="text-right  col-2">
                <i class='bx bxs-trash-alt text-secondary h5' :title="$t('pages.users.delete')" style="cursor:pointer"
                  @click="removeFile(item.file)">
                </i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <p>{{ $t('filemanager.modal.upload.noSelected') }}</p>
      </div>
      <div class="fm-upload-info mt-2">
        <!-- Progress Bar -->
        <div class="progress" v-show="countFiles">
          <div class="progress-bar progress-bar-striped bg-info" role="progressbar" v-bind:aria-valuenow="progressBar"
            aria-valuemin="0" aria-valuemax="100" v-bind:style="{ width: progressBar + '%' }">
            {{ progressBar }}%
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn" v-bind:class="[countFiles ? 'btn-primary' : 'btn-light']"
        v-bind:disabled="!countFiles || !form.comment" v-on:click="uploadFiles">
        {{ $t('filemanager.btn.submit') }}
      </button>
      <button class="btn btn-light" v-on:click="hideModal()">
        {{ $t('filemanager.btn.cancel') }}
      </button>
    </div>
  </div>
</template>

<script>
import modal from "../mixins/modal";
import helper from "../../../router/mixins/helper";
import { mapActions, mapState } from "vuex";

export default {
  name: "ModifyFile",
  mixins: [modal, helper],
  data() {
    return {
      newFiles: [],
      overwrite: 0,
      docType: {},
      docTypes: [],
      classification: 'overall_classification',
      messageError: null,
      form: {
        comment: null
      },
      extension: ".docx",
    };
  },
  watch: {
    classification() {
      this.resetFilesTypes(); 
    },
  },
  computed: {
    /**
     * Progress bar value - %
     * @returns {number}
     */
    progressBar() {
      return this.$store.state.messages.actionProgress;
    },

    /**
     * Count of files selected for upload
     * @returns {number}
     */
    countFiles() {
      return this.newFiles.length;
    },

    uploadHasFilesWithoutTypes() {
      return this.newFiles.some(e => e.type === null);
    },

    /**
     * Calculate the size of all files
     * @returns {*|string}
     */
    allFilesSize() {
      let size = 0;

      for (let i = 0; i < this.newFiles.length; i += 1) {
        size += this.newFiles[i].file.size;
      }

      return this.bytesToHuman(size);
    },

    document() {
      return this.$store.getters['selectedItems'][0];
    },
    ...mapState({
      documentTypes: (state) => state.documentType.documentTypes,
    }),
  },
  methods: {
    ...mapActions(["getDocumentTypes"]),
    resetFilesTypes() {
      this.newFiles = this.newFiles.map(e => {
        return { file: e.file, type: null }
      });
    },
    /**
     * Select file or files
     * @param event
     */
    selectFiles(event) {
      const files = Array.from(event.target.files);
      event.target.value = null;
      files.forEach(file => {
        if (!this.newFiles.some(e => e.file.name === file.name)) {          
          this.newFiles.unshift({
            file,
            type: null
          });
        }
      });
    },
    removeFile(file) {
      this.newFiles = this.newFiles.filter(e => e.file !== file);
    },
    setFileDocumentType(event, fileIndex, file) {
      const type = parseInt(event.target.value);
      this.newFiles.splice(fileIndex, 1, Object.assign(file, { type }));
    },
    setAllFilesDocumentType(event) {
      const type = parseInt(event.target.value);
      this.newFiles = this.newFiles.map(e => {
        return { file: e.file, type };
      });
    },
    /**
     * Upload new files
     */
    uploadFiles() {

      if (this.countFiles > 1) {
        this.$toasted.error("Oups!! \n Vous ne pouvez modifier qu'un seul fichier", {
          duration: 4000,
          position: "top-center",
        });
        this.hideModal();
      }
      else {

        if (this.countFiles) {
          // upload files
          const files = this.newFiles.map(e => {
            return e.file;
          });

          const data = {
            doc_id: this.document.doc_id,
            files: files,
            comment: this.form.comment
          };

          this.$store.dispatch("modify", {
            data,
            overwrite: this.overwrite,
          }).then((response) => {
            if (response.data.result.status === "success" || response.data.result.status === "danger") {
              this.hideModal();
            }
          }).catch(() => {
            
          });
        }
      }
      // if files exists
      
    },
  },
  created() {
    this.getDocumentTypes().then((response) => {
      if (response.status == 200) {
          this.isLoading = false;
          this.documentType = response.data;
        } else {
          this.isLoading = false;
        }
      })
      .catch(() => {
        this.isLoading = false;
      });
  },
};
</script>

<style lang="scss">
.fm-modal-upload {
  .fm-btn-wrapper {
    position: relative;
    overflow: hidden;
    padding-bottom: 6px;
    margin-bottom: 0.6rem;
  }

  .fm-btn-wrapper input[type="file"] {
    font-size: 100px;
    position: absolute;
    left: 0;
    top: 0;
    opacity: 0;
    cursor: pointer;
  }

  .fm-upload-list .far {
    padding-right: 0.5rem;
  }

  .fm-upload-list .form-check-inline {
    margin-right: 0;
  }

  .fm-upload-info>.progress {
    margin-bottom: 1rem;
  }
}
</style>
